import { render } from "./PreventiveMaintenances.vue?vue&type=template&id=5a2fb7f6"
import script from "./PreventiveMaintenances.vue?vue&type=script&lang=js"
export * from "./PreventiveMaintenances.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__